import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import App from "./App";
import "react-day-picker/style.css";
import "./index.css";

// ทุก deploy ชื่อไฟล์ chunk เปลี่ยน (build id ใน vite.config.ts) → แท็บที่เปิดค้างโหลด route ใหม่ไม่ได้
// → รีโหลดหน้าให้เองครั้งเดียว (กันวนด้วย sessionStorage 60 วิ) ถ้ายังพังจะเห็นหน้า error ที่มีปุ่มรีเฟรชตามเดิม
window.addEventListener("vite:preloadError", (event) => {
  try {
    const last = Number(sessionStorage.getItem("kk_chunk_reload_at") || 0);
    if (Date.now() - last < 60_000) return;
    sessionStorage.setItem("kk_chunk_reload_at", String(Date.now()));
  } catch {
    return;
  }
  event.preventDefault();
  window.location.reload();
});

const el = document.getElementById("root");
if (!el) throw new Error("Root element #root not found");

createRoot(el).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>
);
